import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { DatosContacto, createEmptyDatosContacto } from '../../../../contactos/datos-contacto/datos-contacto.model';
import { EquipamientoProcesamiento, createEmptyEquipamientoProcesamiento } from '../../../entity-equipamientos-procesamiento/equipamientos-procesamiento.model';
import { MaquinaMovil } from '../../../entity-maquinas-moviles/entity-maquinas-moviles.model';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import { selectCurrentEmpresa } from '../../../../empresas/entity-mis-empresas/entity-current-empresa.selectors';
import { CorreoElectronico } from '@rpe/registro-personas-empresas-lib';
import { RegistroActividadMaquinariasMovilesFormComponent } from '../registro-actividad-maquinarias-moviles-form/registro-actividad-maquinarias-moviles-form.component';
import { DatosContactoFormComponent } from '../../../../contactos/datos-contacto/datos-contacto-form/datos-contacto-form.component';

@Component({
  selector: 'rpe-registro-actividad-maquinas-moviles-form',
  templateUrl: './registro-actividad-maquinas-moviles-form.component.html',
  styleUrls: ['./registro-actividad-maquinas-moviles-form.component.scss'],
})
export class RegistroActividadMaquinasMovilesFormComponent implements OnInit, OnDestroy {
  @ViewChild("registroActividadMaquinariasMovilesForm") private registroActividadMaquinariasMovilesForm: RegistroActividadMaquinariasMovilesFormComponent
  @ViewChild("datosContactoForm") private datosContactoForm: DatosContactoFormComponent

  @Input() maquinaMovil: MaquinaMovil = null;

  subscriptions: Subscription[] = [];

  @Output() onMaquinaMovilChange: EventEmitter<MaquinaMovil> = new EventEmitter<MaquinaMovil>();
  @Output() onMaquinaMovilValid: EventEmitter<boolean> = new EventEmitter<boolean>();

  equipamientos: {
    equipamiento: EquipamientoProcesamiento,
    status: boolean
  }[] = [];

  datosContacto: DatosContacto = createEmptyDatosContacto()

  maquinaMovilForm: BehaviorSubject<MaquinaMovil> = new BehaviorSubject<MaquinaMovil>({
    id: null,
    entidad_productiva_id: null,
    telefonos: [],
    correos_electronico: [],
    brinda_servicios_terceros: false,
    equipamientos: []
  })

  maquinaForm$: Observable<MaquinaMovil> = this.maquinaMovilForm.asObservable();

  datoContactoValid: boolean = false

  options: {
    value: boolean,
    label: string,
    checked: boolean
  }[] = [
      {
        value: true,
        label: 'Si',
        checked: false
      },
      {
        value: false,
        label: 'No (solo se procesa semilla para uso propio)',
        checked: false
      }
    ]

  get maquinasValid(): boolean {
    return this.equipamientos.every(m => m.status);
  }

  get isAlmotOneOptionChecked(): boolean {
    return this.options.some(o => o.checked);
  }

  constructor(private store: Store<State>) { }

  ngOnInit(): void {
    const s1 = this.store.pipe(select(selectCurrentEmpresa)).subscribe((empresa) => {
      this.maquinaMovilForm.next({
        ...this.maquinaMovilForm.getValue(),
        entidad_productiva_id: empresa.id
      })
    })

    const s2 = this.maquinaForm$.subscribe((maquina) => {
      this.onMaquinaMovilChange.emit(maquina);
    })

    this.subscriptions.push(s1, s2);

    if (this.maquinaMovil) {
      this.maquinaMovilForm.next(this.maquinaMovil);
      this.datosContacto = {
        telefonos: this.maquinaMovil.telefonos,
        correos_electronico: this.maquinaMovil.correos_electronico.map((correoElectronico: CorreoElectronico) => {
          return {
            ...correoElectronico,
            tipo_correo_id: 1
          }
        })
      }
      this.equipamientos = this.maquinaMovil.equipamientos.map(e => ({ equipamiento: e, status: true }));
      this.options = this.options.map(o => {
        return {
          ...o,
          checked: o.value === this.maquinaMovil.brinda_servicios_terceros
        }
      })
    } else {
      this.addMaquinas()
    }

    this.emitValidation();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onRadioChange(event: MatRadioChange): void {
    this.maquinaMovilForm.next({
      ...this.maquinaMovilForm.getValue(),
      brinda_servicios_terceros: event.value
    })

    this.options = this.options.map(o => {
      return {
        ...o,
        checked: o.value === event.value
      }
    })

    this.emitValidation()
  }

  onDatoContactoChange(event: DatosContacto): void {
    this.maquinaMovilForm.next({
      ...this.maquinaMovilForm.getValue(),
      telefonos: event.telefonos,
      correos_electronico: event.correos_electronico.map((correoElectronico: CorreoElectronico) => {
        return {
          ...correoElectronico,
          tipo_correo_id: 1
        }
      })
    })
  }

  datoContactoStatusChange(event: string): void {
    this.datoContactoValid = event === 'VALID';
    this.emitValidation();
  }

  onEquipamientoProcesamientoChange(event: EquipamientoProcesamiento, i: number): void {
    this.equipamientos[i].equipamiento = event;
    this.maquinaMovilForm.next({
      ...this.maquinaMovilForm.getValue(),
      equipamientos: this.equipamientos.map(e => e.equipamiento)
    })
  }

  removeMaquinas(i: number): void {
    this.equipamientos.splice(i, 1);
    this.maquinaMovilForm.next({
      ...this.maquinaMovilForm.getValue(),
      equipamientos: this.equipamientos.map(e => e.equipamiento)
    })
    this.emitValidation();
  }

  onStatusMaquinaChange(event: boolean, i: number): void {
    this.equipamientos[i].status = event;
    this.emitValidation();
  }

  allFormValid(): boolean {
    return this.datoContactoValid && this.maquinasValid && this.isAlmotOneOptionChecked;
  }

  emitValidation(): void {
    if (!this.allFormValid()) this.markAsTouched()
    this.onMaquinaMovilValid.emit(this.allFormValid());
  }

  markAsTouched(): void {
    this.registroActividadMaquinariasMovilesForm?.form.markAllAsTouched()
    this.datosContactoForm?.checkErrors()
  }

  addMaquinas(): void {
    this.equipamientos.push({
      equipamiento: createEmptyEquipamientoProcesamiento(),
      status: false
    });
    this.emitValidation();
  }
}
